export const GET_COLLECTION_STARTED = "GET_COLLECTION_STARTED"
export const GET_COLLECTION_SUCCESS = "GET_COLLECTION_SUCCESS"
export const GET_COLLECTION_FAILED = "GET_COLLECTION_FAILED"